<p-toast></p-toast>
<p-blockUI [blocked]="isLoading">
    <div class="fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center z-5"
        style="background: rgba(0,0,0,0.3);">
        <i class="pi pi-spinner pi-spin" style="font-size: 2rem; color: #000"></i>
    </div>
</p-blockUI>

<p class="exp-subtitle mb-4">Add your work, internship, and volunteer history. CV upload is mandatory.</p>

<div [formGroup]="experiencesForm">
    <div formArrayName="entries">
        <div *ngFor="let exp of entries.controls; let i = index" [formGroupName]="i" class="exp-card mb-4">

            <!-- Card Header -->
            <div class="exp-card-title-row">
                <span class="exp-card-title">Experience</span>
                <button pButton type="button" icon="pi pi-trash"  *ngIf="i >= 1" 
                    class="p-button-danger p-button-text p-button-sm" (click)="removeExperience(i)">
                </button>
            </div>

            <!-- Upload Banner -->
            <div class="w-full mb-3 upload-banner">
                <span class="upload-banner-text">Upload your Resume / CV &nbsp;to autofill this page&nbsp;</span>
                <div class="flex align-items-center">
                    <p-fileUpload class="file-upload-button1" *ngIf="!hasFiles(i)" mode="basic"
                        chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                        (onSelect)="onFileUpload($event, i)" styleClass="file-upload-btn">
                    </p-fileUpload>
                    <div *ngIf="hasFiles(i)" class="uploaded-file-pill flex align-items-center gap-2">
                        <i class="pi pi-file upload-file-icon"></i>
                        <span class="uploaded-file-name cursor-pointer" (click)="openPreview(getUploadedFiles(i)[0])">{{
                            getDocumentDisplayName(i) }}</span>
                        <button pButton type="button" icon="pi pi-times"
                            class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                            (click)="removeFileObj(i)"></button>
                    </div>
                </div>
            </div>
            <small class="p-error block mt-2 mb-2" *ngIf="exp.get('cvFiles')?.hasError('required') && exp.get('cvFiles')?.touched">Resume/CV is required</small>

            <!-- Fields 2-col grid -->
            <div class="exp-field-grid">

                <!-- Organisation Name -->
                <div class="exp-field-group">
                    <label class="exp-field-label">ORGANISATION NAME <span class="exp-required">*</span></label>
                    <input pInputText class="exp-input" formControlName="organisationName"
                        placeholder="Enter org/school name"
                        [ngClass]="{'ng-invalid ng-touched': exp.get('organisationName')?.invalid && exp.get('organisationName')?.touched}" />
                    <small class="p-error block mt-1"
                        *ngIf="exp.get('organisationName')?.hasError('required') && exp.get('organisationName')?.touched">
                        Organisation name is required
                    </small>
                    <small class="p-error block mt-1"
                        *ngIf="exp.get('organisationName')?.hasError('pattern') && exp.get('organisationName')?.touched">
                        Invalid format, only alphabets are allowed
                    </small>
                </div>

                <!-- Duration -->
                <!-- Duration -->
                <div class="exp-field-group">
                    <label class="exp-field-label">
                        DURATION (FROM — TO)
                        <span class="exp-required">*</span>
                    </label>

                    <div class="exp-date-row">
                        <div class="w-6">
                            <p-calendar formControlName="from" [readonlyInput]="true" dateFormat="mm/dd/yy"
                                placeholder="From" styleClass="exp-cal w-full"
                                [ngClass]="{'ng-invalid ng-touched': exp.get('from')?.invalid && exp.get('from')?.touched}">
                            </p-calendar>
                        </div>

                        <span class="exp-date-sep">–</span>

                        <div class="w-6">
                            <p-calendar formControlName="to" [readonlyInput]="true" dateFormat="mm/dd/yy"
                                placeholder="To" styleClass="exp-cal w-full"
                                [ngClass]="{'ng-invalid ng-touched': exp.get('to')?.invalid && exp.get('to')?.touched}">
                            </p-calendar>
                        </div>
                    </div>
                    <small class="p-error block mt-1" *ngIf="(exp.get('from')?.hasError('required') && exp.get('from')?.touched) || (exp.get('to')?.hasError('required') && exp.get('to')?.touched)">
                        Duration is required
                    </small>
                </div>

                <!-- Designation -->
                <div class="exp-field-group">
                    <label class="exp-field-label">DESIGNATION / JOB TITLE <span class="exp-required">*</span></label>
                    <input pInputText class="exp-input" formControlName="designation" placeholder="Job title/role"
                        [ngClass]="{'ng-invalid ng-touched': exp.get('designation')?.invalid && exp.get('designation')?.touched}" />
                    <small class="p-error block mt-1"
                        *ngIf="exp.get('designation')?.hasError('required') && exp.get('designation')?.touched">
                        Designation is required
                    </small>
                    <small class="p-error block mt-1"
                        *ngIf="exp.get('designation')?.hasError('pattern') && exp.get('designation')?.touched">
                        Invalid format, only alphabets are allowed
                    </small>
                </div>

                <!-- Location -->
                <!-- Location -->
                <div class="exp-field-group">
                    <label class="exp-field-label">
                        LOCATION (CITY, COUNTRY)
                        <span class="exp-required">*</span>
                    </label>

                    <div class="flex gap-2 w-full">
                        <div class="w-6">
                            <input pInputText class="exp-input w-full" formControlName="city" placeholder="City"
                                [ngClass]="{
                    'ng-invalid ng-touched':
                    exp.get('city')?.invalid &&
                    exp.get('city')?.touched
                }" />
                        </div>

                        <div class="w-6">
                            <p-dropdown [options]="countryOptions" formControlName="country" placeholder="Country"
                                [showClear]="true" [filter]="true" styleClass="w-full exp-dropdown" [ngClass]="{
                    'ng-invalid ng-touched':
                    exp.get('country')?.invalid &&
                    exp.get('country')?.touched
                }">
                            </p-dropdown>
                        </div>
                    </div>

                    <small class="p-error block mt-1" *ngIf="exp.get('city')?.hasError('required') && exp.get('city')?.touched">
                        City is required
                    </small>
                    <small class="p-error block mt-1" *ngIf="exp.get('city')?.hasError('pattern') && exp.get('city')?.touched">
                        Invalid format, only alphabets are allowed
                    </small>

                    <small class="p-error block mt-1"
                        *ngIf="exp.get('country')?.invalid && exp.get('country')?.touched">
                        Country is required
                    </small>
                </div>
                <!-- Key Responsibilities (full width) -->
                <div class="exp-field-group exp-full-width">
                    <label class="exp-field-label">KEY RESPONSIBILITIES <span class="exp-required">*</span></label>
                    <textarea pInputTextarea class="exp-textarea" formControlName="responsibilities" rows="4"
                        placeholder="Describe your role and impact"
                        [ngClass]="{'ng-invalid ng-touched': exp.get('responsibilities')?.invalid && exp.get('responsibilities')?.touched}">
          </textarea>
                    <small class="p-error block mt-1"
                        *ngIf="exp.get('responsibilities')?.invalid && exp.get('responsibilities')?.touched">
                        Responsibilities are required
                    </small>
                </div>
               <div class="flex flex-column align-items-end mt-3 exp-full-width gap-1">
    <button pButton type="button" 
            [label]="existingIds[i] ? 'Update' : 'Save'"
            [icon]="(savingStates[i] && savingStates[i].saving) ? 'pi pi-check' : 'pi pi-check'"
            [disabled]="(savingStates[i] && savingStates[i].saving)"
            class="p-button-sm p-button-primary border-round-lg font-semibold px-4 save-button"
            (click)="saveEntry(i)">
    </button>
    <p class="text-xs text-red-500 m-0 p-0" *ngIf="exp.dirty">
        You have unsaved changes. Please click {{ existingIds[i] ? 'Update' : 'Save' }} to continue.
    </p>
</div>
            </div>
        </div>

        <!-- Add Another -->
        <div class="mt-4">
            <button pButton label="+ Add Another Experience" type="button" class="exp-add-btn w-full"
                (click)="addExperience()">
            </button>
        </div>

        <p-confirmDialog [style]="{width: '450px'}" styleClass="custom-delete-dialog"></p-confirmDialog>
    </div>

    <input type="file" #hiddenFileInput style="display: none;" (change)="onHiddenFileChange($event)"
        accept="image/*,application/pdf">

    <p-dialog [(visible)]="displayPreviewDialog" [modal]="true" header="File Preview" [dismissableMask]="true"
        [style]="{width: 'auto', 'max-width': '90vw', 'min-width': '50vw'}">
        <div class="text-center p-4 relative" *ngIf="selectedPreviewItem" style="min-height: 250px;">
            <div *ngIf="isPreviewLoading"
                class="absolute top-0 left-0 w-full h-full flex flex-column align-items-center justify-content-center z-2 bg-white-alpha-60">
                <i class="pi pi-spinner pi-spin text-4xl text-primary mb-3"></i>
                <span class="text-600 font-medium font-bold">Loading preview...</span>
            </div>
            <img *ngIf="selectedPreviewItem?.type?.startsWith('image/')" [src]="selectedPreviewItem.previewUrl"
                style="max-width: 100%; max-height: 80vh; border-radius: 8px;" (load)="onPreviewLoad()"
                (error)="onPreviewLoad()">
            <iframe *ngIf="selectedPreviewItem?.type === 'application/pdf' && safePdfUrl" [src]="safePdfUrl"
                width="100%" height="600px" (load)="onPreviewLoad()" style="border: none; border-radius: 8px;">
            </iframe>
        </div>
    </p-dialog>